"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AccountNav = require("../../AccountNav/AccountNav");

var _AccountNav2 = _interopRequireDefault(require("../../AccountNav"));

var _UtilityNav = require("./UtilityNav.style");

var _PrimaryNav = require("../MenuVariants/PrimaryMenu/PrimaryNav/PrimaryNav.style");

var UtilityNav = function UtilityNav(_ref) {
  var account = _ref.account,
      links = _ref.links,
      isLargeNav = _ref.isLargeNav,
      rest = _objectWithoutProperties(_ref, ["account", "links", "isLargeNav"]);

  var hasUtilityLinks = links && links.length > 0;
  return /*#__PURE__*/_react.default.createElement(_UtilityNav.Wrapper, rest, /*#__PURE__*/_react.default.createElement(_UtilityNav.NavContainer, {
    hasUtilityLinks: hasUtilityLinks
  }, hasUtilityLinks && links.map(function (link) {
    return /*#__PURE__*/_react.default.createElement(_UtilityNav.UtilityLinks, Object.assign({
      key: link.label,
      to: link.url,
      enhanced: true
    }, link), link.label);
  }), account && /*#__PURE__*/_react.default.createElement(_PrimaryNav.AccountWrap, {
    account: account
  }, /*#__PURE__*/_react.default.createElement(_AccountNav2.default, {
    account: account,
    variant: "primary",
    isLargeNav: isLargeNav
  }))));
};

UtilityNav.propTypes = {
  isLargeNav: _propTypes.default.bool,
  secondarySliderLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    description: _propTypes.default.string
  })),
  account: _propTypes.default.shape(_AccountNav.accountPropTypes),
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }))
};
UtilityNav.defaultProps = {
  isLargeNav: false,
  secondarySliderLinks: [],
  account: null,
  links: []
};
var _default = UtilityNav;
exports.default = _default;